import { useMutation } from "react-query";
import { searchTasks } from "components/task-list/lib/taskData";
import { useFilterOperators } from "../use-filter-operators";
import { useTransformSortParams } from "../use-transform-sort-params";
import eventEmitter from "shared/events";
import { EVENT_AJAXING } from "shared/data";
import { advancedFiltersFields } from "../../../components/task-list/lib/constants";

export const useSearchTasks = (taskType, outputMapper) => {
    const transformFilters = useFilterOperators(advancedFiltersFields, outputMapper, taskType);
    const transformSortParams = useTransformSortParams();

    return useMutation(({ searchParams, pagingParams, isUsingExternalFilters }) => {
        const params = pagingParams.reduce((param, { id, value }) => {
            // TODO: temporary, remove this when pagination will be unified
            if (id === "pageNumber") {
                value += 1;
            }

            return {
                ...param,
                [id]: value,
            };
        }, []);

        eventEmitter.emit(EVENT_AJAXING);

        return searchTasks(taskType, {
            PagingInfo: {
                PageSize: parseInt(params["pageSize"]),
                PageNumber: parseInt(params["pageNumber"]),
            },
            Filters: transformFilters(searchParams, isUsingExternalFilters),
            sortColumns: transformSortParams(params.originalSort),
        });
    });
};
